import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';


import { MatTooltipModule } from '@angular/material/tooltip';
import { Masks } from '../../../../shared/services/mask.service';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { saveAs } from 'file-saver';
// Imports do projeto
import { CertificadoEmpresaA1Service } from '../../../../shared/services/apis/dfe/certificado_empresa_a1.service';
import { CertificadoIfbService } from '../../../../shared/services/apis/integracao-financas-banco/certificado-ifb.service';
import { FinancasLookupService } from '../../../../shared/services/apis/financas/financas-lookup.service';
import { CertificadoStatusItem } from '../../../../shared/services/responses/integracao-financas-banco/certificados-status.response';
import { StatusCertificadoEnum } from '../../../../shared/enums/certificado/status-certificado.enum';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CertificadoEmpresaA1 } from '../../../../shared/services/models/dfe/certificado_empresa_a1.model';
import { GetCertificadoEmpresaA1Response } from '../../../../shared/services/responses/dfe/certificado_empresa_a1.response';
import { PostCertificadoEmpresaA1Request } from '../../../../shared/services/requests/dfe/certificado_empresa_a1.request';
import { LoadingBoxComponent } from "../../../../shared/components/loading-box/loading-box.component";
import { BaixarCertificadoResponse } from '../../../../shared/services/responses/dfe/baixar-certificado.response';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { VisualizarSenhaModalComponent } from './visualizar-senha-modal/visualizar-senha-modal.component';
import { AuthService } from '../../../../shared/services/apis/usuario/auth.service';
import { UsuarioLoginResponse } from '../../../../shared/services/responses/usuario/usuario-login.response';
import { AlertCardComponent } from '../../../../shared/components/alert-card/alert-card.component';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';


@Component({
  selector: 'app-certificado-e-cnpj',
  imports: [
    HeaderComponent,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatTooltipModule,
    LoadingBoxComponent,
    AlertCardComponent,
    FooterActionComponent
  ],
  providers: [provideNgxMask()],
  templateUrl: './certificado-e-cnpj.component.html',
  styleUrl: './certificado-e-cnpj.component.css',
})
export class CertificadoECNPJComponent implements OnInit {
  public _isLoading: boolean = false;
  public certificado: CertificadoEmpresaA1;
  public statusCertificado: StatusCertificadoEnum = StatusCertificadoEnum.NaoConfigurado;
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public masks: Masks;
  public uploadForm: FormGroup;
  public idCertificadoEmpresaA1: number;
  public userLoginResponse: UsuarioLoginResponse;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private certificadoService: CertificadoEmpresaA1Service,
    private alertService: AlertService,
    private authService: AuthService,
    private certificadoIfbService: CertificadoIfbService,
    private financasLookupService: FinancasLookupService,
  ) {
    this.moduloEnum = ModuloEnum.Configuracoes;
    this.funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_NotasFiscais;
  }

  ngOnInit(): void {
    this.userLoginResponse = this.authService.getUserInfos();
    this.uploadForm = this.formBuilder.group({
      nomeArquivo: [''],
      arquivoCertificado64: ['', Validators.required], // Armazenará o base64
      senhaCertificado: ['', Validators.required]
    });
    this.carregarCertificado();
  }

  carregarCertificado() {
    this._isLoading = true;
    this.certificadoService.getCertificadoAtual().subscribe({
      next: (response: GetCertificadoEmpresaA1Response) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro ao carregar certificado', response.errorDescription, AlertType.error);
          return;
        }

        this.statusCertificado = response.statusCertificado ?? StatusCertificadoEnum.NaoConfigurado;

        if (response.errorCode == 1)
          return;

        this.certificado = response.certificadoEmpresaA1;
        this.idCertificadoEmpresaA1 = response.certificadoEmpresaA1.idCertificadoEmpresaA1;
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error.message || 'Ocorreu um problema ao buscar os dados do certificado.', AlertType.error);
        this._isLoading = false;
      },
    });
  }

  submit(): void {
    if (this.uploadForm.invalid) {
      this.uploadForm.markAllAsTouched(); // Marca todos os campos para exibir os erros
      this.alertService.show('Atenção', 'Por favor, preencha todos os campos obrigatórios.', AlertType.warning);
      return;
    }

    this._isLoading = true;
    const request: PostCertificadoEmpresaA1Request = new PostCertificadoEmpresaA1Request();
    request.arquivoCertificado64 = this.uploadForm.get('arquivoCertificado64')?.value;
    request.senhaCertificado = this.uploadForm.get('senhaCertificado')?.value;
    request.cnpjLogado = this.userLoginResponse.cnpj;

    // Captura o cert/senha recém-fornecidos ANTES do reset — usados na cascata (sem re-baixar cert salvo).
    const base64Enviado: string = request.arquivoCertificado64;
    const senhaEnviada: string = request.senhaCertificado;

    this.certificadoService.postCertificado(request).subscribe({
      next: (response: GetCertificadoEmpresaA1Response) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso!', response.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso!', 'Certificado enviado e atualizado com sucesso.', AlertType.success);
        this.uploadForm.reset();
        this.certificado = response.certificadoEmpresaA1;
        this.statusCertificado = response.statusCertificado ?? StatusCertificadoEnum.NaoConfigurado;
        // Revalida o alerta do certificado fiscal no banner global (atualiza/some).
        this.certificadoService.notificarAlteracao();
        // Cascata: se houver bancos usando o eCNPJ, oferecer atualizar o certificado deles.
        const venc = response.certificadoEmpresaA1?.dataVencimento ?? null;
        this.verificarCascataCertificado(base64Enviado, senhaEnviada, venc);
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error.message || 'Não foi possível enviar o certificado.', AlertType.error);
        this._isLoading = false;
      }
    });
  }

  /**
   * Após trocar o eCNPJ, verifica se há bancos vinculados a ele e, em caso positivo, pergunta ao usuário
   * (modal) se quer propagar o novo certificado para esses bancos (cascata front→IFB direto).
   * Ao fim do fluxo (com ou sem cascata), volta para a listagem de configurações.
   */
  private verificarCascataCertificado(base64: string, senha: string, dataVencimento: Date | string | null): void {
    this.certificadoIfbService.getStatus(true).subscribe({
      next: (status) => {
        if (status.isError) { this.voltarParaConfiguracoes(); return; }
        const vinculados = status.certificados.filter(c => c.usaCertificadoEmpresa);
        if (vinculados.length === 0) { this.voltarParaConfiguracoes(); return; }

        this.buscarNomesContas(vinculados).subscribe(nomes => {
          const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Atualizar certificado dos bancos?',
              innerHtml: `Estes bancos usam o certificado da empresa: <b>${nomes || 'bancos vinculados'}</b>.</br>Deseja atualizar o certificado deles também?`,
              buttonConfirm: 'Sim, atualizar',
              buttonClose: 'Agora não',
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result && result.confirm) {
              this.ressincronizarCertificadoBancos(base64, senha, dataVencimento);
              return;
            }
            this.voltarParaConfiguracoes();
          });
        });
      },
      // Silencioso — cascata é opcional; o certificado já foi enviado com sucesso.
      error: () => this.voltarParaConfiguracoes()
    });
  }

  /**
   * Nomes das contas financeiras dos bancos vinculados ao e-CNPJ, separados por vírgula. O status dos
   * certificados (API IntegracaoFinancasBanco) não traz o nome: vem do lookup de contas da API Financas.
   * Falha no lookup devolve vazio (o modal usa o texto genérico).
   */
  private buscarNomesContas(vinculados: CertificadoStatusItem[]): Observable<string> {
    const ids = new Set(vinculados.map(c => c.idContaFinanceira));
    return this.financasLookupService.listContaFinanceiraSelect().pipe(
      map(res => res.isError ? '' : Array.from(new Set(
        res.list.filter(c => ids.has(c.id)).map(c => (c.descricao || '').trim()).filter(n => n.length > 0)
      )).join(', ')),
      catchError(() => of('')),
    );
  }

  /** Volta para a listagem de configurações de notas fiscais após concluir o envio do certificado. */
  private voltarParaConfiguracoes(): void {
    this.router.navigate(['/configuracoes/notas-fiscais']);
  }

  private ressincronizarCertificadoBancos(base64: string, senha: string, dataVencimento: Date | string | null): void {
    this._isLoading = true;
    this.certificadoIfbService.ressincronizarEmpresa({
      certificadoBase64: base64,
      extensao: 'pfx',
      senha: senha,
      dataVencimento: dataVencimento ? new Date(dataVencimento).toISOString() : null,
    }).subscribe({
      next: (res) => {
        this._isLoading = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription || 'Não foi possível atualizar todos os bancos.', AlertType.warning);
        } else {
          this.alertService.show('Sucesso', `Certificado atualizado em ${res.atualizados} banco(s)${res.falhas ? `, ${res.falhas} falha(s)` : ''}.`, AlertType.success);
        }
        this.certificadoIfbService.notificarAlteracao();
        this.voltarParaConfiguracoes();
      },
      error: () => {
        this._isLoading = false;
        this.alertService.show('Erro', 'Falha ao atualizar o certificado dos bancos.', AlertType.error);
        this.voltarParaConfiguracoes();
      }
    });
  }

  isVencido(): boolean {
    return this.statusCertificado === StatusCertificadoEnum.Vencido;
  }

  baixarCertificado(): void {
    this.certificadoService.baixarCertificado(this.idCertificadoEmpresaA1).subscribe({
      next: (response: BaixarCertificadoResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }

        if (response.certificadoBase64) {
          try {
            const byteCharacters = atob(response.certificadoBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/x-pkcs12' });
            saveAs(blob, this.certificado.nomeArquivo);
          } catch (error) {
            this.alertService.show('Erro', 'Não foi possível processar o arquivo para download.', AlertType.error);
            console.error("Erro ao decodificar ou baixar o arquivo:", error);
          }
        }
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error.message || 'Não foi possível enviar o certificado.', AlertType.error);
        this._isLoading = false;
      }
    });
  }

  visualizarSenha(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Atenção',
        description: `Deseja visualizar a senha do certificado?`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.dialog.open(VisualizarSenhaModalComponent, {
            width: '400px',
            data: {
              idCertificado: this.certificado?.idCertificadoEmpresaA1
            }
          });
        }
      },
    });
  }

  confirmarEnvioCertificado(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Atenção',
        innerHtml: `Deseja enviar um novo certificado? </br>Essa Ação irá sobrescrever o atual e é irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.submit();
        }
      },
    });
  }
  /**
   * Remove o certificado da empresa. Antes de confirmar, consulta os bancos vinculados
   * (usa_certificado_empresa) para avisar que o vínculo será desfeito — os certificados
   * já aplicados nesses bancos continuam valendo.
   */
  removerCertificado(): void {
    this.certificadoIfbService.getStatus(true).subscribe({
      next: (status) => {
        const vinculados = status.isError ? [] : status.certificados.filter(c => c.usaCertificadoEmpresa);
        if (vinculados.length === 0) {
          this.confirmarRemocaoCertificado(false, '');
          return;
        }
        this.buscarNomesContas(vinculados).subscribe(nomes => this.confirmarRemocaoCertificado(true, nomes));
      },
      // Falha ao consultar o status não pode bloquear a remoção — segue com o modal simples.
      error: () => this.confirmarRemocaoCertificado(false, '')
    });
  }

  private confirmarRemocaoCertificado(temVinculados: boolean, nomes: string): void {
    const innerHtml = temVinculados
      ? `Os bancos <b>${nomes || 'vinculados'}</b> usam o certificado da empresa. Ao remover, o vínculo será desfeito (os certificados já aplicados nesses bancos continuam valendo).</br>Essa ação é irreversível. Deseja continuar?`
      : `Deseja remover o certificado?</br>Essa ação é irreversível.`;

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Atenção',
        innerHtml: innerHtml,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.executarRemocaoCertificado(temVinculados);
        }
      },
    });
  }

  private executarRemocaoCertificado(temVinculados: boolean): void {
    this._isLoading = true;
    this.certificadoService.deleteCertificado().subscribe({
      next: (response) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }

        if (temVinculados) {
          this.desvincularCertificadoBancos();
        }

        // Revalida o alerta do certificado fiscal no banner global e volta a tela ao estado "sem certificado".
        this.certificadoService.notificarAlteracao();
        this.certificado = null as any;
        this.statusCertificado = StatusCertificadoEnum.NaoConfigurado;
        this.idCertificadoEmpresaA1 = 0;
        this.alertService.show('Sucesso', 'Certificado removido com sucesso.', AlertType.success);
      },
      error: (error) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error.message || 'Não foi possível remover o certificado.', AlertType.error);
      }
    });
  }

  private desvincularCertificadoBancos(): void {
    const avisoFalha = () => this.alertService.show('Aviso',
      'Certificado removido, mas não foi possível desfazer o vínculo dos bancos. Tente novamente.', AlertType.warning);

    this.certificadoIfbService.desvincularEmpresa().subscribe({
      next: (res) => {
        if (res.isError) {
          avisoFalha();
          return;
        }
        // O vínculo dos bancos mudou: o status de boleto/PIX em cache fica desatualizado.
        this.certificadoIfbService.notificarAlteracao();
      },
      error: () => avisoFalha()
    });
  }

  // --- Métodos de Upload ---

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.processarArquivo(file);
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('dragover');
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processarArquivo(files[0]);
    }
  }

  private processarArquivo(file: File): void {
    if (file && file.name.endsWith('.pfx')) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String = e.target.result.split(',')[1];
        this.uploadForm.patchValue({
          arquivoCertificado64: base64String,
          nomeArquivo: file.name
        });
      };
      reader.readAsDataURL(file);
      this.uploadForm.get('arquivo')?.setErrors(null);
    } else {
      // 4. CORRIGIDO: Limpa o valor e marca o campo como inválido
      this.uploadForm.get('arquivoCertificado64')?.setValue('');
      this.uploadForm.get('arquivoCertificado64')?.setErrors({ 'invalidType': true });
      this.uploadForm.get('nomeArquivo')?.setValue('');
      this.alertService.show('Arquivo Inválido', 'Por favor, selecione um arquivo no formato .pfx', AlertType.warning);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.add('dragover');
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('dragover');
  }

  cancelar() {
    this.router.navigate(['/configuracoes/notas-fiscais']);
  }
}
